<template>
  <el-dialog
    width="20%"
    :visible.sync="this.$store.state.Dialog_Division_ChangeUpper"
    :modal-append-to-body="false"
    :show-close="false"
    :before-close="handleClose"
    class="dialog"
    destroy-on-close
    @open="opendialog"
  >
    <div class="dialog_body">
      <CardHeader :name="headerName" @closeDrawer="handleClose"></CardHeader>
      <el-tree
        class="input_input"
        ref="tree"
        show-checkbox
        :check-strictly="true"
        :default-expand-all="true"
        :data="organizationTree"
        :props="defaultProps"
        node-key="deptId"
        @check="change"
      >
      </el-tree>
      <span slot="footer" class="footer">
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import { authdeptlist, authdeptmobile } from "../../../api/api";
import CardHeader from "../../../components/cardHeader/index.vue";
export default {
  props: ["deptId", "nowChoose"],
  components: { CardHeader },
  name: "dialogTree",
  data() {
    return {
      headerName: "上级部门",
      defaultProps: {
        children: "children",
        label: "deptName",
      },
      organizationTree: [], //组织树
      changeTo: null,
    };
  },

  methods: {
    /**
     * 模态框打开
     * */

    opendialog() {
      this.getTree();
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([this.$props.nowChoose.deptPid]);
        setTimeout(() => {
          this.$refs.tree.setCheckedKeys([this.$props.nowChoose.deptPid]);
        }, 500);
      });
    },

    /**
     * 点击确定
     * */

    onSubmit() {
      if (this.changeTo) {
        let params = {
          deptId: this.$props.deptId,
          targetDeptId: this.changeTo.deptId,
          deptName: this.changeTo.deptName.replace(/\(.*?\)/g, ""),
        };
        authdeptmobile(params).then((res) => {
          this.$store.commit("SET_Refresh_UserList");
          this.$store.commit("SET_Refresh_Organize");
          if (res.code == 200) {
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
            this.$emit('company-handler');
          }
        });
      } else {
        this.$notify.error({
          title: "错误",
          message: "请选择要调整的部门",
        });
      }

      this.handleClose();
    },

    /**
     * 节点选中状态发生变化时的回调
     * */

    change(data, e, l) {
      this.$refs.tree.setCheckedKeys([data.deptId]);
      this.changeTo = data;
    },

    /**
     * 获取组织树
     * */

    getTree() {
      this.organizationTree = [];
      let params = {
        deptPId: this.$props.deptId,
      };
      authdeptlist(params).then((res) => {
        if (res.code == 200) {
          for (let i in res.data) {
            this.organizationTree.push(res.data[i]);
          }
        }
      });
    },

    /**
     * 关闭模态框
     * */

    handleClose() {
      this.$store.commit("SET_Dialog_Division_ChangeUpper", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  .dialog_body {
    height: 31rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .input_input {
      width: 90%;
      padding: 0.9375rem 0px;
      height: 22rem;
      overflow-y: auto;
      box-sizing: border-box;
    }
    .footer {
      margin-top: 1.25rem;
    }
  }
}
</style>